import React, { useState } from 'react';
import './ShowCommandView.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { getShowCommandsWithJWT, getUserWithJWT } from '../../redux/api';
import { toast } from 'react-toastify';

const ShowCommandRedirect = () => {
    const location = useLocation()
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const getTokenAndIdFromUrl = () => {
        const url: any = new URLSearchParams(location.search).toString();
        const keyValuePairs = url.split('&');
        let token: any = "";
        let id: any = "";
        keyValuePairs.forEach((pair: any) => {
            const [key, value] = pair.split('=');
            if (key === "token") {
                token = value;
            } else if (key === "id") {
                id = value.substring(2);
            }
        });
        return { token, id };
    };

    React.useEffect(() => {
        const { token, id } = getTokenAndIdFromUrl();
        getUser(token, id);
    }, [])

    const getUser = (jwtToken: any, commandId?: any) => {
        setIsLoading(true);
        getUserWithJWT(jwtToken).then((res: any) => {
            if (res && res.Response) {
                const usr = res.Response[0]
                getCommand(jwtToken, usr.CustomerAccess[0], commandId)
            }
            setIsLoading(false);
        }).catch((e) => {
            setIsLoading(false)
        })
    }

    const getCommand = (jwtToken: any, customerId: any, commandId?: any, deviceGroupId?: any
    ) => {
        let reqData: any = {
            limit: 1,
            offset: 1,
            id: commandId
        }

        setIsLoading(true);

        getShowCommandsWithJWT(jwtToken, customerId, reqData)
            .then((res: any) => {
                if (res && res.Response) {
                    let cmmand = res.Response.Results[0]
                    if (cmmand.Playlists.length == 1) {
                        localStorage.setItem('isMobile', 'true');
                        navigate(`/mobile/playlist?token=${jwtToken}&id=${cmmand.Playlists[0].PlaylistId}`)
                    }
                    else if (cmmand.Playlists.length > 1) {
                        localStorage.setItem('isMobile', 'true');
                        navigate(`/mobile/multilist?token=${jwtToken}&id=14${cmmand.Id}`)
                    }
                } else {
                    toast.error(res.Error + ': ' + res.Message);
                }
                setIsLoading(false)
            })
            .catch((e) => {
                setIsLoading(false)
                toast.error(e);
            })
    }

    return (
        <div id="splash-screen" className="splash-screen">
            <img src="/media/logos/iToplight_logo.png" alt="iTopLight" />
            <span>Loading ...</span>
        </div>
    );
};

export default ShowCommandRedirect;
